import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { IStransactionType } from '../interfaces/transaction-type.interface';
import { ECategoryType } from '../enums/category.enum';


export class TransactionTypeModel extends BaseModel implements IStransactionType {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  isActive!: boolean;

  @Expose()
  createdAt!: string;

  @Expose()
  createdBy!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  updatedBy!: string

  @Expose()
  description!: string;

  @Expose()
  categoryRole!: string;

  @Expose()
  categoryType!: ECategoryType;
}

